import type { PanelProps } from "../panel-props"

import { useSelectSettings } from "../../../hooks/use-select-settings"
import { useSettings } from "../../../modules/settings"
import { SHORT_SENTENCES_MODES } from "../../../short-sentences/constants"
import { Select } from "../../select"
import { SharedSettings } from "../shared-settings.tsx"

export function ShortSentencesSettings(input: PanelProps) {
  const { appSettings, updateAppSettings } = useSettings()
  const {
    onChange: handleSelectShortSentencesModeChange,
    options: selectShortSentencesModeOptions,
  } = useSelectSettings({
    options: SHORT_SENTENCES_MODES,
    setValue: (newValue: ShortSentencesMode)=> {
      updateAppSettings("shortSentences", { index: 0, mode: newValue })
    },
  })

  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Mode</h3>
        <Select
          initialValue={appSettings.shortSentences.mode}
          label="Mode"
          onChange={handleSelectShortSentencesModeChange}
          options={selectShortSentencesModeOptions}
        />
      </section>
    </SharedSettings>
  )
}
